module.exports = __webpack_public_path__ + "img/chongzhou2.f2c7b291.png";